import { provideHttpUIEffect } from "~/lib/httpUIEffect/index";

export default function (app) {
  provideHttpUIEffect(undefined, app);
}
